import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../lib/api";

const AdminAuthContext = createContext(null);

const TOKEN_KEY = "sabor-liquido-admin-token";

export const AdminAuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(!!token);

    const apiAuth = useCallback(
        (path, options = {}) => {
            return axios({
                url: `${API}${path}`,
                ...options,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token ? `Bearer ${token}` : undefined,
                    ...(options.headers || {}),
                },
            });
        },
        [token],
    );

    useEffect(() => {
        if (!token) {
            setLoading(false);
            return;
        }
        apiAuth("/admin/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem(TOKEN_KEY);
                setToken(null);
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, [token, apiAuth]);

    const login = async (email, password) => {
        const { data } = await axios.post(`${API}/admin/login`, { email, password });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        setToken(data.access_token);
        setUser({ email: data.email, name: data.name, role: "admin" });
    };

    const logout = () => {
        localStorage.removeItem(TOKEN_KEY);
        setToken(null);
        setUser(null);
    };

    return (
        <AdminAuthContext.Provider value={{ token, user, loading, login, logout, apiAuth }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => {
    const ctx = useContext(AdminAuthContext);
    if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
    return ctx;
};
